import React, { useEffect, useState } from 'react';

import { DesktopHeader } from './DesktopHeader/DesktopHeader';
import { MobileHeader } from './MobileHeader/MobileHeader';
import { headerNavLinks, whoIsThisForNavLinks } from '../../routes';

export const Header = () => {
  const [width, setWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 0);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setWidth(window.innerWidth);
    };

    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  const headerProps = {
    navLinks: headerNavLinks,
    whoForNavLinks: whoIsThisForNavLinks
  };

  return <>{width < 1280 ? <MobileHeader {...headerProps} /> : <DesktopHeader {...headerProps} />}</>;
};
